import { ChevronRightIcon, PlusIcon } from "@xola/icons";
import { Button, Skeleton, Spinner } from "@xola/ui-kit";
import clsx from "clsx";
import { noop } from "lodash";
import React from "react";
import { AppLogo } from "./Menu/AppLogo";

const SidebarButton = ({ isActive = false }) => {
    return (
        <div
            className={clsx(
                "flex h-11 w-full rounded bg-gray-light py-2 px-4 xl:px-6",
                isActive && "contrast-75 filter",
            )}
        >
            <span className="ml-2">&nbsp;</span>
        </div>
    );
};

export const LoginSkeleton = ({ email = null }) => {
    const isPurchasesPage = window.location.href.includes("purchases");

    return (
        <div>
            {/* Skeleton for the menu */}
            <Skeleton
                height="100%"
                classNames={{
                    container:
                        "flex flex-col !fixed w-16 md:w-24 xl:w-50 h-full p-2 overflow-y-auto bg-black text-white filter brightness-[98%]",
                    text: "h-full w-full",
                }}
            >
                <div className="mt-11 mb-0 text-center">
                    <AppLogo
                        className={clsx("inline-block h-12 w-12 contrast-0 grayscale-[0.3] filter xl:h-30 xl:w-30")}
                        onClick={noop}
                    />
                </div>
                <div className="flex-grow space-y-1">
                    <SidebarButton isActive />
                    {/* This can be put in a loop, but then React's going to ask for a key which we don't have */}
                    <SidebarButton />
                    <SidebarButton />
                    <SidebarButton />
                    <SidebarButton />
                    <SidebarButton />
                    <SidebarButton />
                    <SidebarButton />
                </div>
                <div className="absolute bottom-0 w-full p-3">
                    <div className="border-t border-secondary-light pb-2" />
                    <div className="flex w-full items-center justify-center rounded py-3 px-4 xl:justify-start">
                        <div className="flex-shrink-0">
                            <div className="h-7 w-7 rounded-full bg-gray-light">&nbsp;</div>
                        </div>
                        <div className="ml-2 w-full min-w-0 text-left">
                            <div className="truncate">{email ?? "Xola User"}</div>
                        </div>
                        <span className="ml-auto">
                            <ChevronRightIcon />
                        </span>
                    </div>
                </div>
            </Skeleton>
            <div className="max-w-1/2 ml-20 h-screen md:ml-24 xl:ml-50">
                {/* Skeleton for the header/search bar */}
                <Skeleton
                    height={81}
                    classNames={{
                        container: "!w-full !bg-white",
                        text: "w-full px-5 pr-3 py-3 xl:px-6 xl:py-5 space-x-2 xl:space-x-6",
                    }}
                >
                    <div className="flex w-full items-center justify-between space-x-3">
                        <div className="w-full text-2xl font-bold">Xola</div>
                        <div className="flex w-full justify-end text-2xl font-bold">
                            <Button disabled color="secondary" className="text-white" icon={<PlusIcon />}>
                                {isPurchasesPage ? "Make a Purchase" : "Purchase"}
                            </Button>
                        </div>
                    </div>
                </Skeleton>
                {/* Skeleton for the body. Just has a loading message */}
                <Skeleton height="80%" classNames={{ container: "border-b-0 h-full !bg-white flex items-center" }}>
                    <div className="space-x-4">
                        <span className="text-2xl">Loading XOLA</span>
                        <Spinner className="relative top-[-2px]" />
                    </div>
                </Skeleton>
            </div>
        </div>
    );
};
